import React from 'react'
import Font from '@cred/react-font'

const CreditNeededInfoContent = () => (
  <div>
    <Font type="bodySmall">
      Each issuer uses a variety of factors and credit scores to make approval decisions.
    </Font>

    <Font className="mt-8" type="bodySmall">
      Credit ranges are defined as:
    </Font>

    <Font className="mt-8" type="bodySmall">
      Excellent (720-850)
    </Font>
    <Font type="bodySmall">Good (690-719)</Font>
    <Font type="bodySmall">Fair (630-689)</Font>
    <Font type="bodySmall">Poor (&lt;630)</Font>
  </div>
)

export { CreditNeededInfoContent as CreditNeededInfoContentNoHoc }
export default CreditNeededInfoContent
